module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAHCAYAAADTcMcaAAAA50lEQVQoU4WPP0rFQBCH81uWmBu8wko7O+20tRNBEDxAit1sAuYOFt4gQlh2ihxAXqcWgoWVndYWWnuDGJIZWfGJPnn4K7+Zb/7AWnuvtc7btn1J/klVVZvjOHZwzu2JCInIcQjheZVXluU6M18BqBCbjDFbSqlrZt4lordl0RgzU0o9MHNBRLefUoy1dhvAzTAMG13X9Que53mWpumriByEEJ4i/5a+Nu4DuMiybKdpmve6rtf6vn8UkVMiulsM+iVF6Jw7YeYzrfXRNE1zAOfe+8ufJ/+RYrEoisMkSToAzns/X/7xA3T4W2ezD24RAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/xia.png
// module id = FQxf
// module chunks = 0